import { global } from ":shared/app";
import { getDate } from "../helpers/get-date";

const endpoint = "teaming/teams/";
export type GET = {
  returns: {
    criteria: { [k: string]: { name: string; min: number; max: number } };
    c_keys: string[];
    history: number[];
    teams: {
      id: number;
      team_name: string;
      eval_id: number;
      project_name: string;
      track: string;
      problem_statement: string;
      research_process: string;
      ideation: string;
      applicable_solution: string;
      feasibility: string;
      impact: string;
      business_model: string;
      project_images: string;
      project_video: string;
      presentation: string;
      is_submitted: boolean;
      submit_time: string;
      eval_time: string;
      is_published: boolean;
      room: number;
      submission_status: "pending" | "done";
      scores: Record<string, number>;
      eval_score: number;
      judging_score: number;
    }[];
  };
};
export async function get(): Promise<GET["returns"]> {
  // return Promise.resolve(
  //   import("./teams.mocks").then((r) => {
  //     const data = r.success as EvaluationData;
  //     data.c_keys = Object.keys(data.criteria);
  //     data.teams.forEach((t) => {
  //       // t.project_video = "https://www.youtube.com/watch?v=wrEK6mm4XpU&ab_channel=Abdodes";
  //       if (t.eval_time && t.eval_time.length > 0) {
  //         t.eval_time = getDate(t.eval_time);
  //       }
  //     });
  //     // const sample = r.success.teams[0];
  //     // console.log("asd :: ", sample.id);
  //     // for (let i = 0; i < 50; i++) {
  //     //   r.success.teams.push(sample);
  //     // }

  //     return data;
  //   })
  // );
  return global.api
    .getAuth(endpoint)
    .then((res) => {
      const data = res.data as GET["returns"];
      data.c_keys = Object.keys(data.criteria);
      data.teams.forEach((t) => {
        // t.project_video = "https://www.youtube.com/watch?v=wrEK6mm4XpU&ab_channel=Abdodes";
        if (t.eval_time && t.eval_time.length > 0) {
          t.eval_time = getDate(t.eval_time);
        }
      });
      return Promise.resolve(data);
    })
    .catch((err) => {
      return Promise.reject(err);
    });
}
